<ion-header class="modal-header">
  <div class="modal-title">
    <h3>{{ id ? "Edit Status" : "Add Status" }}</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        shape="round"
        class="close-button"
        (click)="dismiss()"
      >
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="padding: 16px">
    <ion-label class="input-label"> Name </ion-label>
    <ion-input
      #nameInput
      placeholder="e.g. Waiting for response"
      [(ngModel)]="name"
      class="input-field"
    >
    </ion-input>

    <ion-label class="input-label"> Description (optional) </ion-label>
    <ion-textarea
      placeholder="e.g. Use this status when awaiting a response from the customer"
      [(ngModel)]="description"
      class="input-field"
      rows="3"
      [autoGrow]="true"
    >
    </ion-textarea>
  </div>
</ion-content>

<ion-footer class="footer flex-space-between">
  <ion-button (click)="submit()" [disabled]="isLoading">
    Save
    <ion-spinner
      name="crescent"
      [hidden]="!isLoading"
      style="margin-left: 10px"
    ></ion-spinner>
  </ion-button>
  <div>
    <ion-button
      fill="clear"
      color="dark"
      (click)="delete()"
      [disabled]="isLoading"
      *ngIf="id"
      ngxTippy
      data-tippy-content="Delete"
    >
      <ion-icon name="trash-outline"></ion-icon>
    </ion-button>
  </div>
</ion-footer>
